<template>
  <section class="app-main" style="clear: both;overflow: hidden;">
    <transition name="fade-transform" mode="out-in">
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
export default {

}
</script>

<style>
</style>